import mock from '../mock'

const autoComplete = []

mock.onGet('/api/autocomplete/data').reply(200, {
  autoComplete
})
